import React from 'react';
import '../App.css';
import Hero from '../components/Hero';
import Products from '../components/Products';
import About from '../components/About';
import Certifications from '../components/Certifications';
import Sectors from '../components/Sectors';
import Quote from '../components/Quote';

const Home = () => {
  return (
    <div className="min-h-screen bg-white font-sans">
      <Hero />
      <Products />
      <About />
      <Certifications />
      <Sectors />
      <Quote />
    </div>
  );
};

export default Home;
